module.exports = __webpack_public_path__ + "media/application/images/svgs/github-43b18409b59b6f7a5b6440758e09fd37.svg";